const uniqueId = () =>{
    return (Math.random()*1000000);
}
export  {uniqueId};

